import { Box, Button, Divider, Group, Title } from "@mantine/core";
import React, { useState } from "react";
import { UserPlus } from "tabler-icons-react";
import TicketsTable from "./components/ticketsTable/indext";

export default function Tickets() {
  const [opened, setOpened] = useState(false);
  return (
    <Box p="lg">
      <Group position="apart" mb="md">
        <Title order={2}>Tickets</Title>
        <Group>
          <Button
            leftIcon={<UserPlus size={16} />}
            onClick={() => setOpened(true)}
          >
            Add Ticket
          </Button>
        </Group>
      </Group>
      <Divider mb="md" />
      {/* <TicketsTable /> */}
    </Box>
  );
}
